import React from 'react'
import "./Common_Title.css"

function Common_Title({title}) {
  return (
<>
<section className='Common_Title'>
    <h3>{title}</h3>
</section>
</>
  )
}

export default Common_Title